import { Http } from "../Http";

export class EventDetailsAPI { 
    public static  geteventFlowInitiation(input: any){
 
        var url = "api/geteventdetails/";  
      
         if (input === "") {
           return { data: [] };
         }
      
         const resultMethod = Http.axios()
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        }
      })
      .then(res => {            
        return res;
      })
      .catch((e: any) => {
        return e.response;
      });
    return resultMethod;    
      }
      

    public static   eventFlowInitiationCreate  (input: any){
        var url = "api/eventdetails/";
        var obj=JSON.stringify(input);
      
        if (input === "") {
          return { data: [] };
        }
        const resultMethod = Http.axios().post(url,obj,
          {
            headers: {
              'Content-Type': 'application/json',
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Methods": "*",
              "Access-Control-Allow-Headers": "*"
            }
          })
          .then(res => {
            
            return res;
          }).catch((e: any) => {
            
            return e.response;
          });
        return resultMethod;
      }
      
      public static  eventFlowInitiationUpdate(input: any){
        var url = "eventFlowInitiation/update/";
        var obj=JSON.stringify(input);
        if (input === "") {
          return { data: [] };
        }
        const resultMethod = Http.axios().put(url, obj,
          {
            headers: {
              'Content-Type': 'application/json',
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Methods": "*",
              "Access-Control-Allow-Headers": "*"
            }
          })
          .then(res => {
           
            return res;
          }).catch((e: any) => {
           
            return e.response;
          });
        return resultMethod;
      }
      
      }